(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__smartVideoInit) return;
    window.__smartVideoInit = true;

    var HOVER_QUERY = '(hover: hover) and (pointer: fine)';
    function isHoverDevice() {
      return window.matchMedia(HOVER_QUERY).matches;
    }

    function safePlay(video) {
      try {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function markPlaying(container, on) {
      if (on) container.setAttribute('data-playing', '1');
      else container.removeAttribute('data-playing');
    }

    // ===== START TIME =====
    function getStartTime(container) {
      var t = parseFloat(container.getAttribute('data-start-time') || '0');
      return isFinite(t) && t > 0 ? t : 0;
    }

    function seekToStart(container, video) {
      var st = getStartTime(container);
      try { video.currentTime = st; } catch (e) {}
    }

    function applyStartTime(container, video) {
      var startTime = getStartTime(container);
      if (startTime <= 0) return;

      function seek() {
        try { video.currentTime = startTime; } catch (e) {}
      }

      if (video.readyState >= 1) {
        seek();
      } else {
        video.addEventListener('loadedmetadata', seek, { once: true });
      }

      // Якщо loop увімкнено — петлю робимо з start_time, а не з 0
      video.addEventListener('timeupdate', function () {
        if (video.loop && video.duration && video.currentTime >= video.duration - 0.05) {
          seek();
        }
      });

      // Якщо loop вимкнено — після закінчення повертаємось на start_time для наступного відтворення
      video.addEventListener('ended', function () {
        seek();
      });
    }

    function setupRevealHooks(container, video) {
      var revealed = false;
      function reveal() {
        if (revealed) return;
        revealed = true;
        markPlaying(container, true);
      }
      function hide() {
        revealed = false;
        markPlaying(container, false);
      }
      if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
        video.addEventListener('play', function () {
          video.requestVideoFrameCallback(function () { reveal(); });
        });
      } else {
        video.addEventListener('timeupdate', function () {
          if (video.currentTime > 0) reveal();
        });
      }
      video.addEventListener('pause', hide);
      video.addEventListener('ended', hide);
    }

    function prepVideo(video) {
      video.controls = false;
      video.removeAttribute('controls');
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.removeAttribute('autoplay');
      video.preload = 'auto';
      try { video.load(); } catch (e) {}
    }

    function initHover(container) {
      var video = container.querySelector('video');
      if (!video) return;
      prepVideo(video);
      setupRevealHooks(container, video);
      applyStartTime(container, video);
      try { video.pause(); } catch (e) {}
      markPlaying(container, false);

      // Listen on the wrapper so hovering on the overlay still counts as hovering the video
      var wrap = container.closest('.smart-video-wrap') || container;
      wrap.addEventListener('mouseenter', function () { safePlay(video); });
      wrap.addEventListener('mouseleave', function () {
        video.pause();
        seekToStart(container, video);
        markPlaying(container, false);
      });
    }

    // ----- Mobile: scroll-based "closest to viewport center" picker -----
    var mobileItems = [];
    var activeMobile = null;
    var rafScheduled = false;
    var BOTTOM_THRESHOLD = 80;

    function isPageAtBottom() {
      var scrollY = window.scrollY || window.pageYOffset;
      var viewport = window.innerHeight;
      var docHeight = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight
      );
      return (scrollY + viewport) >= (docHeight - BOTTOM_THRESHOLD);
    }

    function pickActiveMobile() {
      if (!mobileItems.length) return null;
      var viewportH = window.innerHeight;
      var viewportCenter = viewportH / 2;
      var best = null;
      var bestDist = Infinity;

      mobileItems.forEach(function (item) {
        var r = item.container.getBoundingClientRect();
        if (r.bottom <= 0 || r.top >= viewportH) return;
        var elementCenter = r.top + r.height / 2;
        var dist = Math.abs(elementCenter - viewportCenter);
        if (dist < bestDist) {
          bestDist = dist;
          best = item;
        }
      });

      if (isPageAtBottom()) {
        var last = mobileItems[mobileItems.length - 1];
        var lastRect = last.container.getBoundingClientRect();
        if (lastRect.top < viewportH && lastRect.bottom > 0) {
          best = last;
        }
      }
      return best;
    }

    function updateMobilePlayback() {
      rafScheduled = false;
      var next = pickActiveMobile();
      if (next === activeMobile) {
        if (activeMobile && activeMobile.video.paused) safePlay(activeMobile.video);
        return;
      }
      if (activeMobile && activeMobile.video) {
        activeMobile.video.pause();
        seekToStart(activeMobile.container, activeMobile.video);
        markPlaying(activeMobile.container, false);
      }
      activeMobile = next;
      if (activeMobile && activeMobile.video) safePlay(activeMobile.video);
    }

    function scheduleUpdate() {
      if (rafScheduled) return;
      rafScheduled = true;
      requestAnimationFrame(updateMobilePlayback);
    }

    function initMobile(container) {
      var video = container.querySelector('video');
      if (!video) return;
      prepVideo(video);
      setupRevealHooks(container, video);
      applyStartTime(container, video);
      try { video.pause(); } catch (e) {}
      markPlaying(container, false);
      mobileItems.push({ container: container, video: video });
    }

    function sortMobileItemsByPosition() {
      mobileItems.sort(function (a, b) {
        return a.container.getBoundingClientRect().top + window.scrollY
             - b.container.getBoundingClientRect().top - window.scrollY;
      });
    }

    function init(container) {
      if (container.dataset.smartInited === '1') return;
      container.dataset.smartInited = '1';
      if (isHoverDevice()) initHover(container);
      else initMobile(container);
    }

    function initAll() {
      document.querySelectorAll('[data-smart-autoplay]').forEach(init);
      if (!isHoverDevice() && mobileItems.length) {
        sortMobileItemsByPosition();
        scheduleUpdate();
      }
    }

    if (!isHoverDevice()) {
      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', function () {
        sortMobileItemsByPosition();
        scheduleUpdate();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', initAll);
  })();

  (function () {
    if (window.__groupBlockVideoHover) return;
    window.__groupBlockVideoHover = true;

    var HOVER_QUERY = '(hover: hover) and (pointer: fine)';
    function isHoverDevice() {
      return window.matchMedia(HOVER_QUERY).matches;
    }

    function safePlay(video) {
      try {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } catch (e) {}
    }

    function getStartTime(container) {
      var t = parseFloat(container.getAttribute('data-start-time') || '0');
      return isFinite(t) && t > 0 ? t : 0;
    }

    function seekToStart(container, video) {
      var st = getStartTime(container);
      try { video.currentTime = st; } catch (e) {}
    }

    function bind(groupBlock) {
      if (groupBlock.dataset.groupHoverBound === '1') return;

      var smartContainer = groupBlock.querySelector('[data-smart-autoplay]');
      if (!smartContainer) return;

      var video = smartContainer.querySelector('video');
      if (!video) return;

      groupBlock.dataset.groupHoverBound = '1';

      groupBlock.addEventListener('mouseenter', function () {
        safePlay(video);
      });
      groupBlock.addEventListener('mouseleave', function () {
        try { video.pause(); } catch (e) {}
        seekToStart(smartContainer, video);
        smartContainer.removeAttribute('data-playing');
      });
    }

    function bindAll() {
      if (!isHoverDevice()) return;
      document.querySelectorAll('.group-block').forEach(bind);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindAll);
    } else {
      bindAll();
    }

    // Re-bind when sections/blocks are reloaded in the theme editor or after dynamic updates
    document.addEventListener('shopify:section:load', bindAll);
    document.addEventListener('shopify:block:select', bindAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
